// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6409 ? "zieglersim" : chunkId) + "." + {"3630":"4b058fd6","6409":"09842757","7873":"24565726"}[chunkId] + ".chunk.css";
};